(function () {

    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.stickyimageblock = window.oneadvanced.stickyimageblock || {};
    window.oneadvanced.stickyimageblock.init = function () {
        console.log("initialising stickyimageblock...");
            var stickyImageBlock = document.querySelectorAll('[data-si-block-id]');
            if (stickyImageBlock.length) {
                for (var si = 0; si < stickyImageBlock.length; si++) {
                    var anchorID = stickyImageBlock[si],
                    rootBlock = anchorID.parentElement.parentElement,
                    timesToSwap = anchorID.dataset.extraImages,
                    check1 = false,
                    check2 = false,
                    check3 = false,
                    fromTop = [];
                    switch (timesToSwap) {
                        case "1":
                           fromTop = [50];
                           break;
                        case "2":
                            fromTop = [33, 66];
                            break;
                        case "3":
                            fromTop = [25, 50, 75];
                            break;
                        default:
                            break;
                    }

                    for (var i = 0; i < timesToSwap; i++) {
                        var createDiv = document.createElement("div");
                        createDiv.classList.add("swapper" + i);
                        createDiv.style.cssText = "position:absolute;top:" + fromTop[i] + "%;";
                        rootBlock.appendChild(createDiv);
                    }

                    var distance1 = $(rootBlock).find(".swapper0"),
                    distance2 = $(rootBlock).find(".swapper1"),
                    distance3 = $(rootBlock).find(".swapper2");

                    switch (timesToSwap) {
                        case "1":
                            distance1 = distance1.offset().top;
                            check1 = true;
                            break;
                        case "2":
                            distance1 = distance1.offset().top;
                            distance2 = distance2.offset().top;
                            check1 = true;
                            check2 = true;
                            break;
                        case "3":
                            distance1 = distance1.offset().top;
                            distance2 = distance2.offset().top;
                            distance3 = distance3.offset().top;
                            check1 = true;
                            check2 = true;
                            check3 = true;
                            break;
                        default:
                            break;
                    }
                    scroller(rootBlock, distance1, distance2, distance3, check1, check2, check3);
                }
            }

        function scroller(parent, dist1, dist2, dist3, chk1, chk2, chk3) {
            $(window).scroll(function () {
                if ($(window).scrollTop() >= dist1 && chk1 === true) {
                    $(parent).find(".image2").removeClass("stickyimagehidden");
                    $(parent).find(".image1").addClass("stickyimagehidden");
                }
                if ($(window).scrollTop() >= dist2 && chk2 === true) {
                    $(parent).find(".image3").removeClass("stickyimagehidden");
                    $(parent).find(".image2").addClass("stickyimagehidden");
                }
                if ($(window).scrollTop() >= dist3 && chk3 === true) {
                    $(parent).find(".image4").removeClass("stickyimagehidden");
                    $(parent).find(".image3").addClass("stickyimagehidden");
                }
                if ($(window).scrollTop() <= dist1 && chk1 === true) {
                    $(parent).find(".image1").removeClass("stickyimagehidden");
                    $(parent).find(".image2").addClass("stickyimagehidden");
                }
                if ($(window).scrollTop() <= dist2 && $(window).scrollTop() >= dist1 && chk2 === true) {
                    $(parent).find(".image2").removeClass("stickyimagehidden");
                    $(parent).find(".image3").addClass("stickyimagehidden");
                }
                if ($(window).scrollTop() <= dist3 && $(window).scrollTop() >= dist2 && chk3 === true) {
                    $(parent).find(".image3").removeClass("stickyimagehidden");
                    $(parent).find(".image4").addClass("stickyimagehidden");
                }
            });
        }
    };
    window.oneadvanced.stickyimageblock.hasLoaded = true;
})();